import { render, staticRenderFns } from "./donationUnitModal.vue?vue&type=template&id=2aa57ea4&scoped=true&"
import script from "./donationUnitModal.vue?vue&type=script&lang=js&"
export * from "./donationUnitModal.vue?vue&type=script&lang=js&"
import style0 from "./donationUnitModal.vue?vue&type=style&index=0&id=2aa57ea4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa57ea4",
  null
  
)

export default component.exports